import React from "react";
import { Loader2 } from "lucide-react";
import { pulseField, ripple } from "@/lib/pulse";

/** Piezas de vidrio translúcido reutilizables (campos, botones, separador). */

export const GlassField = ({ label, hint, className = "", inputClass = "", ...props }) => (
  <label className={`block ${className}`}>
    {label && <span className="block text-[11px] uppercase tracking-[0.14em] text-white/55 mb-1.5">{label}</span>}
    <input
      {...props}
      onKeyDown={(e) => { pulseField(e.currentTarget); props.onKeyDown?.(e); }}
      className={`glass-field w-full px-3.5 py-2.5 text-[15px] text-white placeholder-white/35 rounded-xl outline-none ${inputClass}`}
    />
    {hint && <span className="block text-[11px] text-white/40 mt-1.5">{hint}</span>}
  </label>
);

export const GlassButton = ({ tone = "neutral", loading, icon: Icon, children, className = "", ...props }) => (
  <button
    {...props}
    onClick={(e) => { ripple(e); props.onClick?.(e); }}
    disabled={props.disabled || loading}
    className={`glass-btn glass-btn-${tone} w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold ${className}`}
  >
    {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : Icon && <Icon className="w-4 h-4" />}
    {children}
  </button>
);

export const GlassDivider = ({ children }) => (
  <div className="flex items-center gap-3 my-6">
    <span className="h-px flex-1 bg-white/12" />
    <span className="text-[10px] uppercase tracking-[0.2em] text-white/45 whitespace-nowrap">{children}</span>
    <span className="h-px flex-1 bg-white/12" />
  </div>
);

export const GoogleIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.6l6.7-6.7C35.5 2.5 30.1 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.8 6.1C12.3 13.2 17.6 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.1 24.5c0-1.6-.1-2.8-.4-4.1H24v8.4h12.4c-.3 2.1-1.6 5.2-4.6 7.3l7.6 5.9c4.4-4.1 6.7-10.1 6.7-17.5z" />
    <path fill="#FBBC05" d="M10.4 28.7A14.6 14.6 0 019.6 24c0-1.6.3-3.2.8-4.7l-7.8-6.1A24 24 0 000 24c0 3.9.9 7.5 2.6 10.8l7.8-6.1z" />
    <path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.8-5.8l-7.6-5.9c-2 1.4-4.7 2.4-8.2 2.4-6.4 0-11.7-3.7-13.6-9l-7.8 6.1C6.5 42.6 14.6 48 24 48z" />
  </svg>
);
